/**
 * Audio Constants
 */

export const AUDIO = {
  DEFAULT_MASTER_VOLUME: 0.25,
  DEFAULT_BEEP_FREQUENCY: 800,
  DEFAULT_BEEP_DURATION_MS: 50,
  DEFAULT_BEEP_VOLUME: 0.1,
} as const;

export const ENVELOPE = {
  TONE_ATTACK_S: 0.005,
  TONE_DECAY_S: 0.01,
  SWEEP_ATTACK_S: 0.005,
  SWEEP_DECAY_S: 0.01,
  CHIRP_ATTACK_S: 0.01,
  CHIRP_SUSTAIN_FACTOR: 0.8,
  CHIRP_FREQ_DURATION_FACTOR: 0.7,
  CLICK_EXPONENTIAL_MIN: 0.001,
} as const;

export const DTMF = {
  DEFAULT_DURATION_MS: 100,
  VOLUME: 0.15,
  ATTACK_S: 0.005,
  DECAY_S: 0.01,
} as const;

export const PHONE_RING = {
  DURATION_S: 0.8,
  VOLUME: 0.12,
  FREQUENCIES: [440, 480] as const,
  ATTACK_S: 0.01,
  DECAY_S: 0.01,
} as const;
